import { ProcessFlowStepType } from "../../enums/processFlowStepType";
import { EnumHelper } from '~/helpers/enumHelper'

export enum ProcessFlowStepCapability {
  titleable = 1,
  jumpToConfigurable,
  actionConfigurable,
  /**
   * If the step can have something go into a variable
   *   e.g. Iteration step having each iteration item go into a variable
   *   e.g. GenerateDocument step having the document go into a variable
   */
  variable,
  modalConfigurable,
  /**
   * No steps can be jumped to from this one
   */
  alwaysFinalStep,
  destroyable,
}

export class ProcessFlowStepCapabilityManager {

  private static controls: { [key in ProcessFlowStepCapability]: ProcessFlowStepType[] } = {
    [ProcessFlowStepCapability.titleable]: [
      ProcessFlowStepType.GenerateDocument,
      ProcessFlowStepType.GenerateDocumentV2,
      ProcessFlowStepType.RunIteration,
      ProcessFlowStepType.SetData,
      ProcessFlowStepType.SaveData,
      ProcessFlowStepType.FindData,
      ProcessFlowStepType.DeleteData,
      ProcessFlowStepType.ExportCSV,
      ProcessFlowStepType.FindCount,
      ProcessFlowStepType.RunProcess,
      ProcessFlowStepType.CallApi,
      ProcessFlowStepType.TakeAction,
      ProcessFlowStepType.SendNotification,
      ProcessFlowStepType.DisplayAForm,
      ProcessFlowStepType.Redirect,
    ],
    [ProcessFlowStepCapability.jumpToConfigurable]: [
      ProcessFlowStepType.InitialStep,
      ProcessFlowStepType.GenerateDocument,
      ProcessFlowStepType.GenerateDocumentV2,
      ProcessFlowStepType.RunIteration,
      ProcessFlowStepType.SetData,
      ProcessFlowStepType.SaveData,
      ProcessFlowStepType.FindData,
      ProcessFlowStepType.DeleteData,
      ProcessFlowStepType.ExportCSV,
      ProcessFlowStepType.FindCount,
      ProcessFlowStepType.RunProcess,
      ProcessFlowStepType.CallApi,
      ProcessFlowStepType.TakeAction,
      ProcessFlowStepType.SendNotification,
    ],
    [ProcessFlowStepCapability.actionConfigurable]: [
      ProcessFlowStepType.DisplayAForm,
    ],
    // step itself can be referenced as a variable
    // shows up in metadata section in config panel
    [ProcessFlowStepCapability.variable]: [
      ProcessFlowStepType.GenerateDocument,
      ProcessFlowStepType.RunIteration,
      ProcessFlowStepType.ExportCSV,
    ],
    [ProcessFlowStepCapability.modalConfigurable]: [
      ProcessFlowStepType.GenerateDocument,
      ProcessFlowStepType.GenerateDocumentV2,
      ProcessFlowStepType.RunIteration,
      ProcessFlowStepType.SetData,
      ProcessFlowStepType.SaveData,
      ProcessFlowStepType.FindData,
      ProcessFlowStepType.DeleteData,
      ProcessFlowStepType.ExportCSV,
      ProcessFlowStepType.FindCount,
      ProcessFlowStepType.RunProcess,
      ProcessFlowStepType.CallApi,
      ProcessFlowStepType.TakeAction,
      ProcessFlowStepType.SendNotification,
      ProcessFlowStepType.DisplayAForm,
      ProcessFlowStepType.Redirect,
    ],
    [ProcessFlowStepCapability.alwaysFinalStep]: [
      ProcessFlowStepType.Redirect,
    ],
    [ProcessFlowStepCapability.destroyable]: EnumHelper.toArray(ProcessFlowStepType).filter(type => type !== ProcessFlowStepType.InitialStep),
  };

  // SECTIONS in Configuration Panel
  static metadataConfigurable = [
    ProcessFlowStepCapability.variable
  ]
  static generalConfigurable = [
    ProcessFlowStepCapability.titleable,
    ProcessFlowStepCapability.modalConfigurable
  ]
  static flowPathConfigurable = [
    ProcessFlowStepCapability.jumpToConfigurable,
    ProcessFlowStepCapability.actionConfigurable,
  ]
  static contextConfigurable = [

  ]

  static can(type: ProcessFlowStepType, capability: ProcessFlowStepCapability): boolean {
    if (!(capability in this.controls)) return false;
    return this.controls[capability].includes(type);
  }

}